const INITIAL_STATE = {
  activeSideBar: { values: [], error: null, loading: false },
};

export default function (state = INITIAL_STATE, action) {
  return {
    ...state,
    activeSideBar: { values: action.payload, error: null, loading: true },
  };
}
